<!--//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//-->

<template>
    <div>
        <v-app-bar fixed app max-width="768" class="mx-auto white darken-5" absolute dense>

            <v-app-bar-nav-icon v-show="false" x-large @click="drawer = true"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>

            <v-img max-width="166" height="48" src="../images/rpd_halfbadge.png"></v-img>
            <v-spacer></v-spacer>

            <v-btn icon text v-show="false">
                <v-icon x-large>$person</v-icon>
            </v-btn>


        </v-app-bar>
        <div id="apptitle" style="max-width:768px; margin: auto; margin-top: 53px;"
             class="text-h5 elevation-2 text-center white font-weight-medium">{{app_title}}</div>
        <v-navigation-drawer id="v-navigation-drawer" height="100" v-model="drawer" absolute temporary>
            <v-list nav dense close-on-click close-on-content-click>
                <v-list-item-group v-model="group" active-class="primary white--text">
                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>$home</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>$logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>

                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        name: 'brandbar',
        data: function () {
            return {
                app_title: "RPD Boarding",
                drawer: false,
                group: null,
            }
        },


    }
</script>

<style scoped>
    i.v-icon.v-icon {
        color: red;
    }

    .v-icon {
        color: #71abcc !important;
    }
</style>